class FeaturedStoriesOdyssey {
  constructor() {
    this.container = document.querySelector('.featured-stories-odyssey');
    if (!this.container) return;
    
    // Main stories elements
    this.flexContainer = this.container.querySelector('.featured-stories-odyssey__flex-container');
    this.storiesWrapper = this.container.querySelector('.featured-stories-odyssey__stories-wrapper');
    this.stories = Array.from(this.container.querySelectorAll('.featured-stories-odyssey__story'));
    
    // Thumbnail elements
    this.leftThumbnailsContainer = this.container.querySelector('.featured-stories-odyssey__thumbnails-container--left');
    this.rightThumbnailsContainer = this.container.querySelector('.featured-stories-odyssey__thumbnails-container--right');
    this.leftThumbnailsWrapper = this.container.querySelector('.featured-stories-odyssey__thumbnails-container--left .featured-stories-odyssey__thumbnails-wrapper');
    this.rightThumbnailsWrapper = this.container.querySelector('.featured-stories-odyssey__thumbnails-container--right .featured-stories-odyssey__thumbnails-wrapper');
    
    this.thumbnails = Array.from(this.container.querySelectorAll('.featured-stories-odyssey__thumbnail'));
    
    // Navigation
    this.prevButton = this.container.querySelector('.stories-highlights__nav-button--prev');
    this.nextButton = this.container.querySelector('.stories-highlights__nav-button--next');
    
    this.storyCount = this.stories.length;
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.autoplayDelay = 3000; // 5 seconds
    
    // Thumbnail dimensions
    this.thumbnailWidth = 0;
    this.thumbnailGap = 0;
    
    this.init();
  }
  
  init() {
    if (this.storyCount <= 0) return;
    
    // Get thumbnail dimensions for calculations
    if (this.thumbnails.length > 0) {
      this.thumbnailWidth = this.thumbnails[0].offsetWidth;
      
      // Get the gap between thumbnails
      if (this.leftThumbnailsWrapper) {
        this.thumbnailGap = parseFloat(getComputedStyle(this.leftThumbnailsWrapper).columnGap) || 0;
      }
    }
    
    // Setup event listeners
    this.prevButton?.addEventListener('click', () => this.navigateStory(-1));
    this.nextButton?.addEventListener('click', () => this.navigateStory(1));
    
    // Add click events to thumbnails
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        this.currentIndex = index;
        this.updateStoryPosition();
        this.resetAutoplayTimer();
      });
    });
    
    // Initialize autoplay
    this.startAutoplay();
    
    // Pause autoplay on hover/touch
    this.storiesWrapper.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.storiesWrapper.addEventListener('mouseleave', () => this.startAutoplay());
    this.storiesWrapper.addEventListener('touchstart', () => this.pauseAutoplay(), { passive: true });
    this.storiesWrapper.addEventListener('touchend', () => this.startAutoplay());
    
    // Window resize handler
    window.addEventListener('resize', this.onResize.bind(this));
    
    // Set initial position
    this.updateStoryPosition();

    setTimeout(() => {
      this.flexContainer.style.opacity = 1; // Ensure correct positioning after initial load
      this.flexContainer.classList.add('loaded');
    }, 300);
  }
  
  onResize() {
    // Update thumbnail dimensions
    if (this.thumbnails.length > 0) {
      this.thumbnailWidth = this.thumbnails[0].offsetWidth;
      
      if (this.leftThumbnailsWrapper) {
        this.thumbnailGap = parseFloat(getComputedStyle(this.leftThumbnailsWrapper).columnGap) || 0;
      }
    }
    
    // Update positions
    this.updateStoryPosition();
  }
  
  navigateStory(direction) {
    this.currentIndex += direction;
    
    // Reset to beginning if we go past the end
    if (this.currentIndex >= this.storyCount) {
      this.currentIndex = 0;
    }
    
    // Go to end if we go before the beginning
    if (this.currentIndex < 0) {
      this.currentIndex = this.storyCount - 1;
    }
    
    this.updateStoryPosition();
    this.resetAutoplayTimer();
  }
  
  updateStoryPosition() {
    // Update main story position
    const translateX = -100 * this.currentIndex;
    this.storiesWrapper.style.transform = `translateX(${translateX}%)`;
    
    // Calculate the item size (width + gap)
    const itemSize = this.thumbnailWidth + this.thumbnailGap;
    
    // LEFT CONTAINER LOGIC
    if (this.leftThumbnailsWrapper && this.leftThumbnailsContainer) {
      let leftOffset;
      
      if (this.currentIndex === 0) {
        // If first slide is active, move all thumbnails out of view to the right
        // Setting a large negative value will move them to the right
        // console.log('item size is', itemSize);
        leftOffset = -this.leftThumbnailsContainer.offsetWidth - (itemSize * 2) - 2;
      } else {
        // Normal case: align the previous story with the right edge
        const prevIndex = this.currentIndex - 1;
        leftOffset = prevIndex * itemSize;
        
        // Add the container width to align with right edge
        leftOffset = leftOffset - this.leftThumbnailsContainer.offsetWidth + itemSize - 2 + 20;
      }
      // console.log('left offset is', leftOffset);
      // Apply the transform
      if (this.currentIndex != 0) {
        this.leftThumbnailsWrapper.style.transform = `translateX(-${Math.max(0, leftOffset)}px)`;
      } else {
        this.leftThumbnailsWrapper.style.transform = `translateX(${itemSize}px)`;
      }
      
    }
    
    // RIGHT CONTAINER LOGIC
    if (this.rightThumbnailsWrapper && this.rightThumbnailsContainer) {
      let rightOffset;
      
      if (this.currentIndex === this.storyCount - 1) {
        // If last slide is active, move all thumbnails out of view to the left
        // Setting a large positive value will move them to the left
        rightOffset = (this.storyCount) * itemSize;
      } else {
        // Normal case: align the next story with the left edge
        const nextIndex = this.currentIndex + 1;
        rightOffset = nextIndex * itemSize + 1;
        
        // Account for the column gap in the right thumbnail wrapper alignment
        // This ensures the next thumbnail aligns perfectly with the left edge
        rightOffset -= this.thumbnailGap;
      }
      
      // Apply the transform
      this.rightThumbnailsWrapper.style.transform = `translateX(-${rightOffset}px)`;
    }
  }
  
  startAutoplay() {
    if (this.autoplayInterval) return;
    
    this.autoplayInterval = setInterval(() => {
      this.navigateStory(1);
    }, this.autoplayDelay);
  }
  
  pauseAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
  
  resetAutoplayTimer() {
    this.pauseAutoplay();
    this.startAutoplay();
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  new FeaturedStoriesOdyssey();
});